import React from 'react';

interface ChevronDownIconProps {
  width?: number;
  height?: number;
  fill?: string;
}

const ChevronDownIcon = ({ width = 24, height = 24, fill = 'black' }: ChevronDownIconProps) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 9L12 15L18 9" stroke={fill || "#3674EE"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);

export default ChevronDownIcon;
